module.exports = "/_next/static/festival-dw.css?1RhrvaV";